import { getSliders } from "@/services/sliderService";
import { useQuery } from "@tanstack/react-query";

const useSliders = () => {
  return useQuery({
    queryKey: ["sliders"],
    queryFn: getSliders,
    staleTime: 1000 * 60 * 10,
    retry: 2,
    retryDelay: 1000,
  });
};
export default useSliders;
